import {defineComponent, defineAsyncComponent, inject, ref} from 'vue';
import {getModule} from 'vuex-module-decorators';
import IDocumenteCertificateUrbanism from '@/types/IDocumenteCertificateUrbanism';
import { ServiceDocumentExtended } from '@/modules/ServiceDocumentExtended';
import {CONFIG_ENV, APP_NAME} from '@/config';
import Nomenclatoare from '@/store/Nomenclatoare';
import User from '@/store/User';
import moment from 'moment';
import LoadingComponent from '@/components/LoadingComponent.vue';
import ErrorComponent from '@/components/ErrorComponent.vue';
import {dateToStringDDMonYYYY} from '@/modules/Utils';
import IActionOnStepTask from '@/types/IActionOnStepTask';
import Notify from 'quasar/src/plugins/Notify.js';;
import IStatusLabel from '@/types/IStatusLabel';

// type OrNull<T> = { [K in keyof T]: T[K] | null }
// type IDocumenteCertificateUrbanismNull = OrNull<IDocumenteCertificateUrbanism>;

const TaskList = defineAsyncComponent({
  loader: () => import('@/components/Tasks/TaskList.vue'),
  loadingComponent: LoadingComponent,
  errorComponent: ErrorComponent,
  // The error component will be displayed if a timeout is
  // provided and exceeded. Default: Infinity.
  timeout: 3000,
  delay: 200
});

const myForm = ref({} as any);
const myForm1 = ref({} as any);
const qDateProxy1 = ref(null);
const qDateProxy2 = ref(null);

export default defineComponent({
  name: 'EditCertificateUrbanismDetail',

  components: {
    TaskList
  },

  props: {    
	  appid: {
      type: Number,
      required: true,
      default: 0,
      readonly: true
    },
    closeWindow: {
      type: Function,
      default: undefined
    },
    task: {
      type: Object,
      task_id: 0,
      task_type: '',
      action_on_step: {} as IActionOnStepTask
    }
  },

  setup() { 
    const emitter = inject("emitter") as any;     
    return {
      emitter,
      myForm,
      myForm1,
      qDateProxy1,
      qDateProxy2
    }  
  },

  data() {    
    return {
      documenteCertificateUrbanism: {} as IDocumenteCertificateUrbanism,
      myLocale: CONFIG_ENV.myLocale,      
      nomenclatoareStore: getModule(Nomenclatoare),
      loadingData: false,
      userStore: getModule(User),
      isSuccess: false,
      showPreviewFile: false,
      titleForPreviewForm: '',
      downloadingFile: false,
      urlBlobForPreviewFile: '',
      isPDFFileType: false,
      documentatie_tehnica_flag: [] as number[],
      avize_si_acorduri_privind_utilitati_flag: [] as number[],
      avize_si_acorduri_privind_flag: [] as number[]
    }
  },

  methods: {        
    displayData(pdata:string) :string{
      if(pdata){
        const day = moment(pdata.substring(0,10), 'YYYY-MM-DD');
        return dateToStringDDMonYYYY(day);
      }else{ 
        return '';
      }
    },

    getDocumenteCertificateUrbanism() {
      const vueInst = this;
      ServiceDocumentExtended.getDocumentCertificateUrbanism(Number(vueInst.documenteCertificateUrbanism.appid)).then((presponse)=>{
        vueInst.loadingData = false;
        if(presponse.status==='success'){
          vueInst.documenteCertificateUrbanism = presponse.documenteCertificateUrbanism as IDocumenteCertificateUrbanism;

          if ((vueInst.documenteCertificateUrbanism.documentatie_tehnica & 1) != 0) {
            vueInst.documentatie_tehnica_flag.push(1);
          }
          if ((vueInst.documenteCertificateUrbanism.documentatie_tehnica & 2) != 0) {
            vueInst.documentatie_tehnica_flag.push(2);
          }
          if ((vueInst.documenteCertificateUrbanism.documentatie_tehnica & 4) != 0) {
            vueInst.documentatie_tehnica_flag.push(4);
          }
          ///////////////////////////////////////////////////////////////////////////
          if ((vueInst.documenteCertificateUrbanism.avize_si_acorduri_privind_utilitati & 1) != 0) {
            vueInst.avize_si_acorduri_privind_utilitati_flag.push(1);
          }
          if ((vueInst.documenteCertificateUrbanism.avize_si_acorduri_privind_utilitati & 2) != 0) {
            vueInst.avize_si_acorduri_privind_utilitati_flag.push(2);
          }
          if ((vueInst.documenteCertificateUrbanism.avize_si_acorduri_privind_utilitati & 4) != 0) {
            vueInst.avize_si_acorduri_privind_utilitati_flag.push(4);
          }
          if ((vueInst.documenteCertificateUrbanism.avize_si_acorduri_privind_utilitati & 8) != 0) {
            vueInst.avize_si_acorduri_privind_utilitati_flag.push(8);
          }
          if ((vueInst.documenteCertificateUrbanism.avize_si_acorduri_privind_utilitati & 16) != 0) {
            vueInst.avize_si_acorduri_privind_utilitati_flag.push(16);
          }
          if ((vueInst.documenteCertificateUrbanism.avize_si_acorduri_privind_utilitati & 32) != 0) {
            vueInst.avize_si_acorduri_privind_utilitati_flag.push(32);
          }
          if ((vueInst.documenteCertificateUrbanism.avize_si_acorduri_privind_utilitati & 64) != 0) {
            vueInst.avize_si_acorduri_privind_utilitati_flag.push(64);
          }
          if ((vueInst.documenteCertificateUrbanism.avize_si_acorduri_privind_utilitati & 128) != 0) {
            vueInst.avize_si_acorduri_privind_utilitati_flag.push(128);
          }
          ///////////////////////////////////////////////////////////////////////////
          if ((vueInst.documenteCertificateUrbanism.avize_si_acorduri_privind & 1) != 0) {
            vueInst.avize_si_acorduri_privind_flag.push(1);
          }
          if ((vueInst.documenteCertificateUrbanism.avize_si_acorduri_privind & 2) != 0) {
            vueInst.avize_si_acorduri_privind_flag.push(2);
          }
          if ((vueInst.documenteCertificateUrbanism.avize_si_acorduri_privind & 4) != 0) {
            vueInst.avize_si_acorduri_privind_flag.push(4);
          }

          vueInst.isSuccess = true;
        }
      })
    },

    onState(operator: string){
      switch(operator) {
        case 'Refresh':
          this.getDocumenteCertificateUrbanism();
          break;
        case 'Close':          
          this.closeWindow?.();
          break;
      }
    },

    onPreviewCerere() {
      const vueInst = this;

      vueInst.titleForPreviewForm = 'Vizualizare';
      vueInst.downloadingFile = true;
      vueInst.showPreviewFile = true;
      
      let urlToGetFile = `${CONFIG_ENV.URL_DOCUMENTEXTENDED.downloadScanForPreviewFromAppDocCertificateUrbanism}/${vueInst.documenteCertificateUrbanism.appid}`;        

      fetch(urlToGetFile, { 
        headers: 
          (['APP_DEV', 'APP_URBANESQ'].includes(APP_NAME)) ? 
            {
              odocsuserid: vueInst.userStore.User.userid.toString(),
              odocsusertoken: vueInst.userStore.User.csrf_token
            } : 
            {
              Odocsuserid: vueInst.userStore.User.userid.toString(),
              Odocsusertoken: vueInst.userStore.User.csrf_token
            }
       })
      .then(resp => resp.blob())
      .then(blob => {
        vueInst.urlBlobForPreviewFile = window.URL.createObjectURL(blob);
        vueInst.isPDFFileType = blob.type == 'application/pdf';

        if (vueInst.isPDFFileType) {
          if (this.$q.platform.is.mobile) {
            setTimeout(function () {
              vueInst.downloadingFile = false;
              const divPreview = window.document.getElementById('iframe_preview_scan') as HTMLIFrameElement
              if(divPreview){
                divPreview.src = '/' + 'pdf_viewer/web/viewer.html?file=' + vueInst.urlBlobForPreviewFile; 
              }
            }, 500);
          } else {// is desktop
            setTimeout(function () {
              vueInst.downloadingFile = false;
              const divPreview = window.document.getElementById('iframe_preview_scan') as HTMLIFrameElement;
              if(divPreview){
                divPreview.src = vueInst.urlBlobForPreviewFile; 
              }
            }, 500);
          }
        } else {
          blob.text().then(text => {
            Notify.create({
              color: 'red',
              textColor: 'white',
              type: 'negative',
              message: text,
              position: 'top',
              timeout: 3500,
              html: true
            });

            setTimeout(() => {
              vueInst.showPreviewFile = false;
            }, 1000);
          });
        }
      })
      .catch((err) => {
          Notify.create({
            color: 'red',
            textColor: 'white',
            type: 'negative',
            message: err.message ? 'Eroare! Fisierul nu poate fi descarcat! ' + err.message : 'Eroare! Fisierul nu poate fi descarcat!',
            position: 'top',
            timeout: 3500,
            html: true
          })
      });
    },

    getDenStatus(pStatus: string): string{
      const vueInst=this;
      let result = '' as string;
      const Status = vueInst.optionsStatus.find(status =>{
        return status.status == pStatus;
      });
      if(Status){
        result=Status.label;
      }
      return result;
    },

    displayDataRO(pdata:Date) :string{
      if(pdata){
        const day = moment(pdata, 'YYYY-MM-DD');
        return dateToStringDDMonYYYY(day);
      }else{ 
        return '';
      }
    },
  },

  computed: {
    APP_NAME(): string{
      return APP_NAME;
    },
    
    optionsStatus() {
      const statusArray = [
        {status: 'init', label: 'Initiat'},
        {status: 'initiat', label: 'Initiat'},
        {status: 'pending', label: 'In lucru'}, 
        {status: 'inapproval', label: 'In aprobare'},
        {status: 'approved', label: 'Aprobat'},
        {status: 'authorizationissued', label: 'Autorizatie emisa'}
      ];

      return statusArray;
    }
  },

  mounted() {
    const vueInst = this;
    // vueInst.nomenclatoareStore.set_currentpagetitle('Certificate de urbanism');
  },

  watch: {
    appid: {
      immediate: true,
      handler (newVal: number, oldVal: number) {        
        const vueInst = this;        

        vueInst.loadingData = true;
        if(newVal != 0 && vueInst.appid != 0) {                    
          vueInst.documenteCertificateUrbanism.appid = vueInst.appid;            
          vueInst.getDocumenteCertificateUrbanism();
        }
      }
    }
  }
});